export const CHANGE_BULL_PHISH_ORGANIZATION_SELECT = 'CHANGE_BULL_PHISH_ORGANIZATION_SELECT';
